import { render, staticRenderFns } from "./CaseTranscript.vue?vue&type=template&id=8688011c&scoped=true&lang=pug&"
import script from "./CaseTranscript.vue?vue&type=script&lang=js&"
export * from "./CaseTranscript.vue?vue&type=script&lang=js&"
import style0 from "./CaseTranscript.vue?vue&type=style&index=0&id=8688011c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8688011c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VIcon,VSnackbar})
